export const learnersSchoolData = {
  english: {
    title: "Learn to Drive with Step by Step",
    drive: "Drive",
    sections: {
      videos: "Video Lessons",
      papers: "Past Papers",
      handbook: "Driving Hand Book",
    }
  },

  sinhala: {
    title: "පියවරෙන් පියවර ඉගෙන ගන්න",
    drive: "පියවරෙන් පියවර",
    sections: {
      videos: "වීඩියෝ පාඩම්",
      papers: "පසුගිය ප්‍රශ්න පත්‍ර",
      handbook: "රියදුරු අත්පොත",
    }
  },

  tamil: {
    title: "படிப்படியாக வாகனம் ஓட்ட கற்றுக்கொள்ளுங்கள்",
    drive: "ஓட்ட",
    sections: {
      videos: "வீடியோ பாடங்கள்",
      papers: "முந்தைய வினாத்தாள்கள்",
      handbook: "வாகன ஓட்டுநர் கையேடு",
    }
  }
};
